import { IExportColumnModel } from "../../../../../shared/models";

export const ChangeHistoryColumnList: IExportColumnModel[] = [
    {
        isAllChecked: true,
        name: "Fields from dashboard change histories",
        value: "dashboard_change_histories",
        columns: [
            {
                name: "Id",
                value: "id",
                checked: true,
            },
            {
                name: "Item Type",
                value: "item_type",
                checked: true,
            },
            {
                name: "Item Id",
                value: "item_id",
                checked: true,
            },
            {
                name: "Event",
                value: "event",
                checked: true,
            },
            {
                name: "Edited By",
                value: "whodunnit",
                checked: true,
            },
            {
                name: "Old Value",
                value: "object",
                checked: true,
            },
            {
                name: "New Value",
                value: "object_changes",
                checked: true,
            },
             {
                name: "Created At",
                value: "created_at",
                checked: true,
            },
             {
                name: "IP",
                value: "ip",
                checked: true,
            },
             {
                name: "Dashboard Id",
                value: "dashboard_id",
                checked: true,
            }           
        ]

    },
    {
        isAllChecked: true,
        name: "Fields from associated dashboard",
        value: "dashboards",
        columns: [
            {
                name: "Id",
                value: "id",
                checked: true,
            },
             {
                name: "User Id",
                value: "user id",
                checked: true,
            }, 
            {
                name: "Dashboard Name",
                value: "name",
                checked: true,
            },
            {
                name: "Created At",
                value: "created_at",
                checked: true,
            },
            {
                name: "Updated At",
                value: "updated_at",
                checked: true,
            }, 
            {
                name: "Viewed At",
                value: "viewed_at",
                checked: true,
            },
            {
                name: "Settings",
                value: "settings",
                checked: true,
            },       
        ]

    },
]